import { PageHeader } from "@/components/page-header";
import { useT } from "@/lib/i18n";

/**
 * Tiny client wrapper around `PageHeader` so the `/teams` page (an
 * RSC) can render i18n labels without becoming a client component
 * itself. Pattern matches `mcp-page-header.tsx`.
 */
export function TeamsPageHeader() {
  const t = useT();
  return (
    <PageHeader
      eyebrow={t("common.eyebrow.workspace")}
      title={t("teams.title")}
      subtitle={t("teams.subtitle")}
    />
  );
}
